import { Box, Typography } from "@mui/material";
import React from "react";

const CardInfo = ({ data }) => {
  return (
    <Box
      sx={{
        color: "#000",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "1rem",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontSize: { sm: "35px", xs: "25px" } }}>
          {data.title}
        </Typography>
        <Typography
          component={"img"}
          src={data?.icon}
          sx={{
            width: "70px",
            // height:"70px"
          }}
        />
      </Box>
      <Typography sx={{ fontSize: { sm: "25px", xs: "20px" }, pt: "1rem" }}>
        {data.subtitle}
      </Typography>
    </Box>
  );
};

export default CardInfo;
